import http from './http';

export async function sendChatMessage(message, history = []) {
  const { data } = await http.post('/ai/chat', { message, history });
  return data; // { reply: string }
}
